export default __webpack_public_path__ + "static/media/clubops.c3ca60fd.png";